module.exports = __webpack_public_path__ + "img/orders.cc25a97c.svg";